import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProductBundleOptionsComponentDef } from '@df/catalog-ui/product/bundle-options/product-bundle-options.component.def';
import { ProductConfigurationBundle } from '@df/module-product-configuration/model/bundle/product-configuration-bundle';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { TimeoutService } from '@df/ng/timeout.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

/**
 *
 *
 * ## Usage (from any product component)
 *
 * ```html
 * <product-bundle-options [product]="model"
 *      [buyRequest]="request.bundle_options"></product-bundle-options>
 * ````
 */
@Component({
    selector: 'product-bundle-options',
    templateUrl: './product-bundle-options.html',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBundleOptionsComponent extends ProductBundleOptionsComponentDef {
    private readonly productConfiguration = inject(ProductConfiguration) as ProductConfigurationBundle;

    constructor(_ref: ChangeDetectorRef, timeoutService: TimeoutService) {
        super(_ref, timeoutService);
        this.productConfiguration.bundleOptions$.pipe(takeUntilDestroyed()).subscribe(bundleOptions => {
            bundleOptions?.forEach(option => {
                if (option?.data.required && option?.values.length === 1) {
                    option.setQty(option.values[0].data.selection_id, 1);
                }
            });
            this.detectChanges();
        });
    }
}
